import { render, staticRenderFns } from "./AdminChatLink.vue?vue&type=template&id=d035a886&scoped=true"
import script from "./AdminChatLink.vue?vue&type=script&lang=js"
export * from "./AdminChatLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d035a886",
  null
  
)

export default component.exports